<div class="grid">
    <div class="col-12">
        <div class="card">
            <h4>Editar Empresa - {{ empresa?.nomeFantasia }}</h4>
            <form *ngIf="empresa" #f="ngForm" name="form">
                <div class="formgroup">
                    <p-tabView styleClass="tabview-custom" (onChange)="abaSelecionada($event)">
                        <p-tabPanel>
                            <ng-template pTemplate="header">
                                <i class="pi pi-list mr-1"></i>
                                <span>Dados Básicos</span>
                            </ng-template>
                            <div class="p-fluid p-formgrid grid">
                                <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                                    <p-messages
                                        [(value)]="messages"
                                        [enableService]="false"
                                        [closable]="true"
                                    ></p-messages>
                                </div>
                                <div class="col-12 md:col-12">
                                    <h5>Dados Principais</h5>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label htmlFor="nomeFantasia">Nome Empresa</label>
                                    <input
                                        oninput="this.value = this.value.toUpperCase();"
                                        type="text"
                                        pInputText
                                        [(ngModel)]="empresa.nomeFantasia"
                                        placeholder="Digite o nome da Empresa"
                                        name="nomeFantasia"
                                        ngModel
                                        #nomeFantasia="ngModel"
                                        required
                                    />
                                </div>
                                <div class="field col-12 md:col-5">
                                    <label htmlFor="razaoSocial">Razão Social*</label>
                                    <input
                                        oninput="this.value = this.value.toUpperCase();"
                                        type="text"
                                        pInputText
                                        [(ngModel)]="empresa.razaoSocial"
                                        placeholder="Digite a Razão Social"
                                        name="razaoSocial"
                                        ngModel
                                        #razaoSocial="ngModel"
                                        required
                                    />
                                    <div
                                        *ngIf="
                                            razaoSocial.hasError('required') && razaoSocial.touched
                                        "
                                        class="alerta"
                                    >
                                        <small>Campo obrigatório</small>
                                    </div>
                                </div>
                                <div class="field col-12 md:col-3">
                                    <label htmlFor="cnpj">CNPJ</label>
                                    <p-inputMask
                                        mask="99.999.999/9999-99"
                                        [unmask]="true"
                                        type="text"
                                        [(ngModel)]="empresa.cnpjCpf"
                                        placeholder="00.000.000/0000-00"
                                        name="cnpj"
                                        ngModel
                                        #cnpj="ngModel"
                                    ></p-inputMask>
                                </div>

                                <div class="field col-12 md:col-4">
                                    <label htmlFor="email">E-mail</label>
                                    <input
                                        pInputText
                                        type="email"
                                        placeholder="seuemail@mail.com"
                                        name="email"
                                        ngModel
                                        [(ngModel)]="empresa.email"
                                        email="true"
                                        #email="ngModel"
                                    />
                                    <div *ngIf="email.hasError('email')" class="alerta">
                                        <small>Digite um e-mail válido</small>
                                    </div>
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label>Logo da Empresa</label>
                                    <p-fileUpload
                                        mode="basic"
                                        chooseLabel="Escolher"
                                        chooseIcon="pi pi-upload"
                                        name="demo[]"
                                        [auto]="true"
                                        accept="image/*"
                                        (onSelect)="salvarLogo($event)"
                                        accept="image/*"
                                        [maxFileSize]="1000000"
                                    ></p-fileUpload>
                                </div>
                                <div class="field col-12 md:col-4">
                                    <label htmlFor="email" *ngIf="!logoData">
                                        Sem Logo definida!
                                    </label>

                                    <p-image
                                        *ngIf="logoData"
                                        [src]="logoData"
                                        alt="Image"
                                        width="250"
                                    ></p-image>
                                </div>

                                <div class="col-12 md:col-12">
                                    <h5>Endereço</h5>
                                </div>

                                <div class="field col-12 md:col-2">
                                    <label htmlFor="cep">CEP</label>
                                    <p-inputMask
                                        mask="99999-999"
                                        [unmask]="true"
                                        placeholder="00000-000"
                                        name="cep"
                                        ngModel
                                        [(ngModel)]="empresa.cep"
                                        #cep="ngModel"
                                    ></p-inputMask>
                                </div>

                                <div class="field col-12 md:col-6">
                                    <label htmlFor="logradouro">Logradouro</label>
                                    <input
                                        #inputLogradouro
                                        oninput="this.value = this.value.toUpperCase();"
                                        pInputText
                                        type="text"
                                        name="logradouro"
                                        ngModel
                                        #logradouro="ngModel"
                                        [(ngModel)]="empresa.logradouro"
                                    />
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label htmlFor="bairro">Bairro</label>
                                    <input
                                        pInputText
                                        type="text"
                                        name="bairro"
                                        ngModel
                                        oninput="this.value = this.value.toUpperCase();"
                                        [(ngModel)]="empresa.bairro"
                                        #bairro="ngModel"
                                    />
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label htmlFor="numero">Número</label>
                                    <input
                                        pInputText
                                        type="text"
                                        name="numero"
                                        ngModel
                                        #numero="ngModel"
                                        [(ngModel)]="empresa.numero"
                                    />
                                </div>
                                <div class="field col-12 md:col-3">
                                    <label htmlFor="complemento">Complemento</label>
                                    <input
                                        oninput="this.value = this.value.toUpperCase();"
                                        pInputText
                                        type="text"
                                        name="complemento"
                                        ngModel
                                        #complemento="ngModel"
                                        [(ngModel)]="empresa.complemento"
                                    />
                                </div>

                                <div class="field col-12 md:col-2">
                                    <label htmlFor="uf">UF</label>
                                    <input
                                        oninput="this.value = this.value.toUpperCase();"
                                        pInputText
                                        type="text"
                                        name="uf"
                                        ngModel
                                        #uf="ngModel"
                                        [(ngModel)]="empresa.uf"
                                    />
                                </div>

                                <div class="field col-12 md:col-7">
                                    <label htmlFor="cidade">Cidade</label>
                                    <input
                                        oninput="this.value = this.value.toUpperCase();"
                                        pInputText
                                        type="text"
                                        name="cidade"
                                        ngModel
                                        #cidade="ngModel"
                                        [(ngModel)]="empresa.cidade"
                                    />
                                </div>

                                <div class="col-12 md:col-12">
                                    <h5>Contatos</h5>
                                </div>

                                <div class="field col-12 md:col-3">
                                    <label htmlFor="telefone">Telefone</label>
                                    <p-inputMask
                                        mask="(99)9999-9999"
                                        [unmask]="true"
                                        type="text"
                                        placeholder="(00)0000-0000"
                                        [(ngModel)]="empresa.telefone"
                                        name="telefone"
                                        ngModel
                                        #telefone="ngModel"
                                    ></p-inputMask>
                                </div>

                                <div class="field col-12 md:col-3">
                                    <label htmlFor="whatsapp">Whatsapp</label>
                                    <p-inputMask
                                        mask="(99)99999-9999"
                                        [unmask]="true"
                                        type="text"
                                        placeholder="(00)00000-0000"
                                        [(ngModel)]="empresa.whatsapp"
                                        name="whatsapp"
                                        ngModel
                                        #whatsapp="ngModel"
                                    ></p-inputMask>
                                </div>
                            </div>
                            <div class="p-fluid p-formgrid grid justify-content-end">
                                <div class="field col-12 md:col-2">
                                    <button
                                        type="button"
                                        pButton
                                        icon="pi pi-check"
                                        label="Atualizar"
                                        class="p-button-success mt-5"
                                        (click)="atualizar()"
                                    ></button>
                                </div>
                                <div class="field col-12 md:col-8"></div>
                                <div class="field col-12 md:col-2">
                                    <button
                                        type="button"
                                        pButton
                                        icon="pi pi-arrow-left"
                                        label="Voltar"
                                        class="p-button-primary mt-5"
                                        routerLink="/rfarias/empresa"
                                    ></button>
                                </div>
                            </div>
                        </p-tabPanel>
                        <p-tabPanel header="Usuários">
                            <ng-template pTemplate="header">
                                <i class="pi pi-user mr-1"></i>
                                <span>Usuários</span>
                            </ng-template>
                            <ng-template pTemplate="context">
                                <div
                                    class="p-fluid p-formgrid grid"
                                    *ngIf="eventoAbaUsuario == 'LISTAR'"
                                >
                                    <div class="field col-12 md:col-2">
                                        <button
                                            pButton
                                            pRipple
                                            label="Novo"
                                            (click)="inserirUsuario()"
                                            icon="pi pi-plus"
                                            class="p-button-info mr-2 mb-2"
                                        ></button>
                                    </div>
                                </div>
                                <app-usuario-empresa-listar
                                    *ngIf="eventoAbaUsuario == 'LISTAR'"
                                    [empresa]="empresa"
                                    (emissor)="trocarComponenteUsuario($event)"
                                ></app-usuario-empresa-listar>
                                <app-usuario-empresa-inserir
                                    *ngIf="eventoAbaUsuario == 'INSERIR'"
                                    [empresa]="empresa"
                                    (emissor)="trocarComponenteUsuario($event)"
                                ></app-usuario-empresa-inserir>

                                <app-usuario-empresa-editar
                                    *ngIf="eventoAbaUsuario == 'EDITAR'"
                                    [id]="idUsuarioEmpresa"
                                    [empresa]="empresa"
                                    (emissor)="trocarComponenteUsuario($event)"
                                ></app-usuario-empresa-editar>
                                <app-usuario-empresa-detalhar
                                    *ngIf="eventoAbaUsuario == 'DETALHAR'"
                                    [id]="idUsuarioEmpresa"
                                    [empresa]="empresa"
                                    (emissor)="trocarComponenteUsuario($event)"
                                ></app-usuario-empresa-detalhar>
                            </ng-template>
                        </p-tabPanel>
                        <p-tabPanel header="Planos">
                            <ng-template pTemplate="header">
                                <i class="pi pi-user mr-1"></i>
                                <span>Plano de Contas</span>
                            </ng-template>
                            <ng-template pTemplate="context">
                                <div
                                    class="p-fluid p-formgrid grid"
                                    *ngIf="eventoAbaPlanoConta == 'LISTAR'"
                                >
                                    <div class="field col-12 md:col-2">
                                        <button
                                            pButton
                                            pRipple
                                            label="Novo"
                                            (click)="inserirPlanoContaEmpresa()"
                                            icon="pi pi-plus"
                                            class="p-button-info mr-2 mb-2"
                                        ></button>
                                    </div>
                                </div>
                                <app-plano-contas-empresa-listar
                                    *ngIf="eventoAbaPlanoConta == 'LISTAR'"
                                    [empresaSelecionada]="empresa"
                                    (emissor)="trocarComponentePlanoConta($event)"
                                ></app-plano-contas-empresa-listar>
                                <app-plano-conta-empresa-inserir
                                    *ngIf="eventoAbaPlanoConta == 'INSERIR'"
                                    (emissor)="trocarComponentePlanoConta($event)"
                                    [empresa]="empresa"
                                ></app-plano-conta-empresa-inserir>
                                <app-plano-conta-empresa-editar
                                    *ngIf="eventoAbaPlanoConta == 'EDITAR'"
                                    [id]="idPlanoContaEmpresa"
                                    (emissor)="trocarComponentePlanoConta($event)"
                                ></app-plano-conta-empresa-editar>
                                <app-plano-conta-empresa-detalhar
                                    *ngIf="eventoAbaPlanoConta == 'DETALHAR'"
                                    [id]="idPlanoContaEmpresa"
                                    (emissor)="trocarComponentePlanoConta($event)"
                                ></app-plano-conta-empresa-detalhar>
                            </ng-template>
                        </p-tabPanel>
                        <p-tabPanel header="Tributação">
                            <ng-template pTemplate="header">
                                <i class="pi pi-user mr-1"></i>
                                <span>Tributação</span>
                            </ng-template>
                            <ng-template pTemplate="context">
                                <div class="formgroup" *ngIf="eventoAbaTributacao == 'LISTAR'">
                                    <div class="p-fluid p-formgrid grid">
                                        <div class="field col-12 md:col-2">
                                            <button
                                                pButton
                                                pRipple
                                                label="Novo"
                                                icon="pi pi-plus"
                                                class="p-button-info mr-2 mb-2"
                                                (click)="inserirTributacao()"
                                            ></button>
                                        </div>
                                    </div>
                                </div>
                                <app-tributacao-listar
                                    *ngIf="eventoAbaTributacao == 'LISTAR'"
                                    (emissor)="trocarComponenteTributacao($event)"
                                    [empresa]="empresa"
                                ></app-tributacao-listar>
                                <app-tributacao-inserir
                                    *ngIf="eventoAbaTributacao == 'INSERIR'"
                                    [empresa]="empresa"
                                    (emissor)="trocarComponenteTributacao($event)"
                                ></app-tributacao-inserir>
                                <app-tributacao-editar
                                    *ngIf="eventoAbaTributacao == 'EDITAR'"
                                    [id]="idTributacao"
                                    (emissor)="trocarComponenteTributacao($event)"
                                ></app-tributacao-editar>
                            </ng-template>
                        </p-tabPanel>
                    </p-tabView>
                    <p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>
                </div>
            </form>
        </div>
    </div>
</div>
